import * as yup from 'yup';

export const validationSchema = yup.object({
    cashRegisterDate: yup.date().typeError("Must be a valid date").required("Required"),
    startingBalance: yup.number().typeError("Must be a valid number").required("Required"),
    cashOnHand: yup.number().typeError("Must be a valid number").required("Required")
})